import { render, staticRenderFns } from "./HomeSalesRadarChart.vue?vue&type=template&id=15352dcf&"
import script from "./HomeSalesRadarChart.vue?vue&type=script&lang=js&"
export * from "./HomeSalesRadarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports